/**
 * TierBadge - Launch mode tier badge
 */
import React from 'react';
import { Crown, Zap, Shield, Rocket } from 'lucide-react';

export const getModeInfo = (launchMode) => {
  switch (launchMode) {
    case 'ultra':
      return { label: 'ULTRA', color: '#00D9FF', icon: Shield, gradient: 'linear-gradient(135deg, #00D9FF 0%, #0099CC 100%)' };
    case 'max':
      return { label: 'MAX', color: '#FFD700', icon: Crown, gradient: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)' };
    case 'pro':
      return { label: 'PRO', color: '#9945FF', icon: Zap, gradient: 'linear-gradient(135deg, #9945FF 0%, #7B2CBF 100%)' };
    case 'basic':
    default:
      return { label: 'BASIC', color: '#4CAF50', icon: Rocket, gradient: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)' };
  }
};

const TierBadge = ({ launchMode }) => {
  const modeInfo = getModeInfo(launchMode);
  
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      padding: '3px 8px',
      background: modeInfo.gradient,
      borderRadius: '4px',
      boxShadow: `0 2px 8px ${modeInfo.color}40`,
    }}>
      <modeInfo.icon size={10} style={{ color: launchMode === 'basic' || launchMode === 'max' ? '#000' : '#fff' }} />
      <span style={{
        fontSize: '9px',
        fontWeight: 800,
        color: launchMode === 'basic' || launchMode === 'max' ? '#000' : '#fff',
        letterSpacing: '0.5px',
      }}>
        {modeInfo.label}
      </span>
    </div>
  );
};

export default TierBadge;
